/** @jsxImportSource @emotion/react */

import { FC, useMemo } from 'react'
import UAParser from 'ua-parser-js'
import { Typography } from '@mui/material'
import { findAllIpLog_findAllIpLog_items } from '__generatedTypes__/findAllIpLog'
import { DeviceTypeEnum } from '__generatedTypes__/globalTypes'
import * as tabsClasses from '../styles'
import * as classes from './styles'

type Props = {
  detailedIpLogItem: findAllIpLog_findAllIpLog_items | null
}

const getDeviceType = (deviceType?: DeviceTypeEnum | null) => {
  if (deviceType === DeviceTypeEnum.Desktop) {
    return 'Web'
  }

  if (deviceType === DeviceTypeEnum.MobileBrowser) {
    return 'Mobile Browser'
  }

  if (deviceType === DeviceTypeEnum.Mobile) {
    return 'Mobile App'
  }

  return 'Unknown'
}

export const DetailedIpLogModalContent: FC<Props> = ({ detailedIpLogItem }) => {
  const { browserId, userAgent, deviceType } = detailedIpLogItem || {}

  const parsedUA = useMemo(() => {
    if (!userAgent) {
      return {
        browser: null,
        os: null,
        device: null,
      }
    }

    const parser = new UAParser(userAgent)
    return parser.getResult()
  }, [userAgent])

  return (
    <div>
      <Typography variant="title3" css={tabsClasses.title}>
        Device info
      </Typography>
      <p>
        Type:
        <span css={classes.ipLogDeviceInfoValue}> {getDeviceType(deviceType)}</span>
      </p>
      <p>
        Browser id:
        <span css={classes.ipLogDeviceInfoValue}> {browserId}</span>
      </p>
      <p>
        Browser:
        {parsedUA.browser ? (
          <span css={classes.ipLogDeviceInfoValue}>
            {' '}
            {parsedUA.browser.name} {parsedUA.browser.version}
          </span>
        ) : (
          <span>N/A</span>
        )}
      </p>
      <p>
        OS:
        {parsedUA.os ? (
          <span css={classes.ipLogDeviceInfoValue}>
            {' '}
            {parsedUA.os.name} {parsedUA.os.version}
          </span>
        ) : (
          <span>N/A</span>
        )}
      </p>
      <p>
        Device:
        {parsedUA.device ? (
          <span css={classes.ipLogDeviceInfoValue}>
            {' '}
            {parsedUA.device.model} {parsedUA.device.type} {parsedUA.device.vendor}
          </span>
        ) : (
          <span>N/A</span>
        )}
      </p>
    </div>
  )
}
